import * as _4 from 'lodash4';
import { AuthenticationConfiguration } from '../configuration/authentication_configuration';
import { AccountStatusDatastore } from '../datastore/account_status_datastore';
import { AccountIdentityDatastore } from '../datastore/account_identity_datastore';
import { AccountModel } from '../models/account_model';
import { MemberConfigurationDatastore } from '../datastore/member_configuration_datastore';
export class AuthenticationQueryModel {
  constructor(
    private authenticationConfiguration: AuthenticationConfiguration,
    private ngAccountIdentityDatastore: AccountIdentityDatastore,
    private ngAccountStatusDatastore: AccountStatusDatastore,
    private ngMemberConfigurationDatastore: MemberConfigurationDatastore,
    private appConfigModel: any
  ) {}

  isAccountLoggedOut() {
    return _4.isEmpty(this.ngAccountIdentityDatastore.store.username);
  }

  isAccountLoggedIn() {
    return !this.isAccountLoggedOut();
  }

  isAccountValid() {
    return this.isAccountLoggedIn();
  }

  isMemberValid() {
    return !_4.isEmpty(this.ngMemberConfigurationDatastore.store.login_url);
  }

  // NOTE this was used in a view - ready for what?
  isReady() {
    return this.isMemberValid();
  }

  hasAssignedInstitution() {
    return !!this.ngMemberConfigurationDatastore.store.inst_name;
  }

  // NOTE replace backgroundUrl
  getBackgroundImageURL() {
    const logonConfigurationStore = this.ngMemberConfigurationDatastore.store;
    const authenticationConfiguration = this.authenticationConfiguration.read();

    return (
      logonConfigurationStore.login_header_url ||
      this.appConfigModel.getInstitutionMediaPath('core_login') ||
      authenticationConfiguration.defaultBackgroundImageUrl
    );
  }

  read() {
    return {
      identity: this.ngAccountIdentityDatastore.store,
      status: this.ngAccountStatusDatastore.store,
      member: this.ngMemberConfigurationDatastore.store
    };
  }

  report(fn: (a: any) => void) {
    return fn(this.read());
  }
}
angular
  .module('data-ng-authentication')
  .factory(
    'ngAuthenticationQueryModel',
    (
      authenticationConfiguration: any,
      ngAccountIdentityDatastore: AccountIdentityDatastore,
      ngAccountStatusDatastore: AccountStatusDatastore,
      ngMemberConfigurationDatastore: any,
      appConfigModel: any
    ) =>
      new AuthenticationQueryModel(
        authenticationConfiguration,
        ngAccountIdentityDatastore,
        ngAccountStatusDatastore,
        ngMemberConfigurationDatastore,
        appConfigModel
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/queries/authentication_query_model.ts